import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Press } from '@dorixona/ui'
import { OtpInput } from './ui/OtpInput'
import { displayPhone, isCompleteCode } from './model'
import { AuthHero } from './AuthHero'

export interface CodeStepProps {
  phone: string
  code: string
  onCodeChange: (code: string) => void
  onSubmit: () => void
  onResend: () => void
  resendIn: number
  pending: boolean
  error: string | undefined
}

export function CodeStep({
  phone,
  code,
  onCodeChange,
  onSubmit,
  onResend,
  resendIn,
  pending,
  error,
}: CodeStepProps) {
  const { t } = useTranslation('auth')
  const complete = isCompleteCode(code)

  // Код набран — подтверждаем сами: в нативном приложении не просят нажать
  // кнопку после четвёртой цифры.
  useEffect(() => {
    if (complete && !pending) onSubmit()
    // onSubmit намеренно вне зависимостей: пересоздаётся на каждый рендер.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [complete])

  return (
    <>
      <AuthHero
        title={t('code.title')}
        subtitle={t('code.subtitle', { phone: displayPhone(phone) })}
      />
      <OtpInput
        value={code}
        onChange={onCodeChange}
        digitLabel={(position) => t('code.digit', { position })}
        invalid={Boolean(error)}
        disabled={pending}
        focusOnShow
      />
      <p className={error ? 'auth-error' : 'auth-note'} role={error ? 'alert' : undefined}>
        {error ?? t(pending ? 'code.checking' : 'code.hint')}
      </p>
      <Button loading={pending} disabled={!complete} onPress={onSubmit}>
        {t('code.submit')}
      </Button>
      <p className="auth-note">
        {resendIn > 0 ? (
          t('code.resendIn', { seconds: resendIn })
        ) : (
          <Press squish="chip" className="linkbtn" disabled={pending} onPress={onResend}>
            {t('code.resend')}
          </Press>
        )}
      </p>
    </>
  )
}
